export class Result<T> {
    public success: boolean = false;
    public data: T | null = null;
    public message: string = '';
    public responseCode: number = 0;
    public customResponseCode: string = '';

    public copyExceptData<U>(result: Result<U>) {
        if (null === result) {
            return this;
        }

        this.success = result.success;
        this.message = result.message;
        this.responseCode = result.responseCode;
        this.customResponseCode = result.customResponseCode;

        return this;
    }
}
